import { buildFetchMutations } from '@/store/extensions/fetch';
import { buildCreateMutations } from '@/store/extensions/create';
import { buildUpdateMutations } from '@/store/extensions/update';
import { buildDeleteMutations } from '@/store/extensions/delete';

export default {
  ...buildFetchMutations(['fetchRoles']),
  ...buildCreateMutations(['createRole']),
  ...buildUpdateMutations(['updateRole']),
  ...buildDeleteMutations(['removeRole']),
};



// WEBPACK FOOTER //
// ./src/store/modules/role/mutations.js